import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import logo from "../../../assets/img/logo.png";
import Cookies from "js-cookie";
import { logout } from "../../../redux/authentication/authSlice";
import { MODULES, setSelectedModule, selectAppModule } from "../../../redux/appModule/appModuleSlice";
import { useEffect, useState } from "react";
import mainlogo from "../../../assets/img/mainlogo.svg";
import Logo from "../../../assets/svg/logo.svg";
import playStore from "../../../assets/img/playstore.png"
import { Breaker, Div, Flexbox, ToggleButton, WrapperBox } from "../../../MakersV2/Theme/GlobalStyles";
import { globalTheme } from "../../../MakersV2/Theme/Theme";
import { Text } from "../../../MakersV2/Theme/Typography";
import { LogOut, MakersLogo,CoworkLogo, BloomBergLogo, BloomBergLogoBlack, CoworkLogoText, CoworkLogoTextWhite, EduspaceLogoWhite, AngleLeft, AngleRight } from "../../../MakersV2/Theme/Icons";
import InitialsAvatar from "../../../MakersV2/Components/InitialsAvatar";
import LogoutPopup from "../../../MakersV2/Components/Popup/LogoutPopup";
import { useAvailableModules } from "../../../MakersV2/Components/ModuleSwitcher";
import { ToolTip } from "../../../MakersV2/Components/ToolTip/ToolTip";

const MainSideMenu = ({ menuItems, isActiveMenu, setIsActiveMenu }) => {
	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();
	const selectedModule = useSelector(selectAppModule);

	// Highlight the menu item matching the current URL. Exact match for the root
	// path; prefix match otherwise so nested routes (e.g. detail pages) keep their
	// parent tab active.
	const isMenuItemActive = (path) => {
		if (!path) return false;
		const current = location.pathname;
		return path === "/" ? current === "/" : current === path || current.startsWith(`${path}/`);
	};
	const isCowork = selectedModule === MODULES.COWORK;
	// Only show the module toggle when the user can access more than one module.
	const { canSwitch } = useAvailableModules();
	const authData = JSON.parse(Cookies.get("loginData"));
	
	const [hovered, setHovered] = useState(null);
	const [popupState, setPopupState] = useState(false);
	const [allowLogout, setAllowLogout] = useState(false);
	const [menuOpen, setMenuOpen] = useState(false);
	// Collapsed sidebar (icon-only). Persisted so the choice survives reloads.
	const [collapsedPref, setCollapsed] = useState(() => {
		try { return localStorage.getItem("sidebarCollapsed") === "1"; } catch (e) { return false; }
	});
	// Below 992px the sidebar is an off-canvas drawer (see .mainSideMenuWrap in
	// GlobalStyles). An icon-only drawer makes no sense — it hides the logo and
	// labels while CSS forces the panel back to full width — so the collapse
	// preference is ignored while in drawer mode.
	const [isDrawerMode, setIsDrawerMode] = useState(
		() => typeof window !== "undefined" && window.matchMedia("(max-width: 992px)").matches
	);
	useEffect(() => {
		const mq = window.matchMedia("(max-width: 992px)");
		const onChange = (e) => setIsDrawerMode(e.matches);
		setIsDrawerMode(mq.matches);
		mq.addEventListener("change", onChange);
		return () => mq.removeEventListener("change", onChange);
	}, []);
	const collapsed = isDrawerMode ? false : collapsedPref;

	// Keep the page behind the drawer from scrolling while it's open.
	useEffect(() => {
		if (!isDrawerMode) return;
		const previous = document.body.style.overflow;
		document.body.style.overflow = isActiveMenu ? "hidden" : previous;
		return () => {
			document.body.style.overflow = previous;
		};
	}, [isDrawerMode, isActiveMenu]);
	const rolesCookie = Cookies.get("roles");
	const rolesArray = rolesCookie ? JSON.parse(rolesCookie) : [];
	// const rolesArray = JSON.parse(Cookies.get("roles"));
	const userRole = rolesArray; // Example roles (array of roles)
	const roleText =
		rolesArray?.includes("Cowork Class Admin") || rolesArray?.includes("Cowork Lab Admin") || rolesArray?.includes("Cowork Admin") || rolesArray?.includes("BMB Admin") ? "Admin" :
		rolesArray?.includes("Cowork Lab Student") || rolesArray?.includes("Cowork Student") || rolesArray?.includes("BMB Student") ? "Student" :
		rolesArray?.includes("Cowork Staff") ? "Staff" :
		rolesArray?.includes("Cowork Faculty") ? "Faculty" :
		"none";
	console.log("userRole", userRole);
	const currentUrl = window.location.hostname;
	const isClassroomTheme = currentUrl.includes('classroom.mastersunion.org') || currentUrl.includes('classroom')  ||  currentUrl.includes('localhost') 
							//  currentUrl.includes('127.0.0.1');
	const isCoworkTheme = currentUrl.includes('cowork.mastersunion.org') ;
	const isMakersLabTheme = currentUrl.includes('makerslab.mastersunion.org') || currentUrl.includes('makersv2') || currentUrl.includes('127.0.0.1');
	useEffect(() => {
		const handleLogout = () => {
			// Get an array of all cookie names
			var allCookies = Object.keys(Cookies.get());

			// Loop through the cookie names and remove each cookie
			allCookies.forEach(function (cookieName) {
				Cookies.remove(cookieName);
			});
			dispatch(logout());
			navigate("/login");
		};
		if (allowLogout) {
			handleLogout();
		}
	}, [allowLogout]);

	// Navigating from inside the drawer (logo, menu row) should dismiss it.
	useEffect(() => {
		if (isDrawerMode) setIsActiveMenu(false);
	}, [location.pathname]);

	const toggleMenu = () => {
		setMenuOpen(!menuOpen);
	};

	const toggleCollapse = () => {
		setCollapsed((prev) => {
			const next = !prev;
			try { localStorage.setItem("sidebarCollapsed", next ? "1" : "0"); } catch (e) {}
			return next;
		});
	};

	return (
		<>
			<LogoutPopup
				showActive={popupState}
				message={"Are you sure you want to log out? You will need to sign in again to access your account."}
				onCancel={setPopupState}
				onAllow={setAllowLogout}
			/>
			<span
				className="overlay"
				onClick={() => setIsActiveMenu(false)}
				style={{
					opacity: `${isActiveMenu ? 1 : ""}`,
					visibility: `${isActiveMenu ? `visible` : ""}`,
				}}
			></span>
			<div
				className={`mainSideMenuWrap ${isActiveMenu ? "isOpen" : ""}`}
				style={{
					height: '100vh',
					width: collapsed ? 88 : 260,
					minWidth: collapsed ? 88 : 260,
					boxSizing: 'border-box',
					background: globalTheme.colors.black4,
					padding: collapsed ? '24px 14px' : '30px 20px',
					// Visible so the collapsed-state tooltips can spill over the content.
					overflow: 'visible',
					flexShrink: 0,
					transition: 'width 0.25s ease, min-width 0.25s ease, padding 0.25s ease',
				}}
			>
				{/* Logo + collapse toggle */}
				<Flexbox alignCenter spaceBW={!collapsed} contentCenter={collapsed} className="mb30" style={{ minHeight: 40 }}>
					{!collapsed && (
						<div
							className={`${(userRole.includes("Cowork Class Admin") || userRole.includes("Cowork Class User")) ? '' : 'sideLogoBlockMaker'} pointer`}
							onClick={() => {
								navigate("/user-dashboard");
							}}
						>
							{selectedModule === MODULES.EDUSPACE ? (
								<EduspaceLogoWhite/>
							) : selectedModule === MODULES.MAKERSLAB ? (
								<MakersLogo/>
							) : selectedModule === MODULES.BLOOMBERG ? (
								<BloomBergLogo/>
							) : (
								<CoworkLogoTextWhite/>
							)}
						</div>
					)}
					<button
						type="button"
						className="sidebarCollapseBtn"
						onClick={toggleCollapse}
						aria-label={collapsed ? 'Expand menu' : 'Collapse menu'}
						title={collapsed ? 'Expand' : 'Collapse'}
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							width: 32,
							height: 32,
							borderRadius: 8,
							flexShrink: 0,
							cursor: 'pointer',
							background: 'rgba(255,255,255,0.08)',
							border: '1px solid rgba(255,255,255,0.14)',
						}}
					>
						{collapsed ? <AngleRight color={globalTheme.colors.white1}/> : <AngleLeft color={globalTheme.colors.white1}/>}
					</button>
				</Flexbox>

				<Flexbox wrap spaceBW column height='calc(100% - 70px)'>
					<div style={{ width: '100%', overflow: 'visible' }}>
						{menuItems.map((menuItem, index) => {
							const active = isMenuItemActive(menuItem.path);
							const row = (
								<ToolTip content={menuItem.label} position="Right" hide={!collapsed} zIndex="9999" minWidth="max-content" maxWidth="max-content">
									<Flexbox gap={12} alignCenter padding={collapsed ? '12px' : '12px 14px'} borderRadius={12}
										contentCenter={collapsed}
										background={active ? 'rgba(255, 255, 255, 0.08)' : 'transparent'}
										onMouseEnter={() => setHovered(index)}
										onMouseLeave={() => setHovered(null)}
										className={`pointer ${active ? "active" : ""} `}
										onClick={() => {
											navigate(menuItem.path);
											setIsActiveMenu(false);
										}}
									>
										{/* Icons are single-tone grey SVGs with hardcoded fills, so state
										    is conveyed via filter: brightened to white when active/hovered
										    (grey ×1.8 clamps to #fff), dimmed to read as disabled otherwise —
										    mirroring the label's white/grey2 treatment. */}
										<span
											style={{
												display: 'inline-flex',
												alignItems: 'center',
												flexShrink: 0,
												filter: (active || hovered === index) ? 'brightness(1.8)' : 'none',
												opacity: (active || hovered === index) ? 1 : 0.55,
												transition: 'filter 0.15s ease, opacity 0.15s ease',
											}}
										>
											{menuItem.icon}
										</span>
										{!collapsed && (
											<Text font16 inter semiBold {...((hovered === index || active) ? {white:true} : {grey2:true})}>{menuItem.label}</Text>
										)}
									</Flexbox>
								</ToolTip>
							);
							return (
								<div
									key={index}
									// Collapsed: flex + centered so the icon-only pill (wrapped in the
									// tooltip) sits in the middle. Expanded: plain block so the row
									// keeps its full width (active-row highlight spans the sidebar).
									style={collapsed
										? { display: 'flex', justifyContent: 'center', marginBottom: 6 }
										: { marginBottom: 6 }}
								>
									{row}
								</div>
							);
						})}
					</div>

					<div style={{ width: '100%' }}>
						<Breaker borderColor={globalTheme.colors.nuetral13} marginTop={24} marginBottom={24}/>
						<div style={{ display: 'flex', justifyContent: collapsed ? 'center' : 'flex-start' }}>
							<ToolTip
								content={
									<Flexbox column gap={4} alignStart style={{ padding: '2px 4px' }}>
										<Text font13 inter medium white style={{ whiteSpace: 'nowrap' }}>
											{`${authData?.firstName || ''} ${authData?.lastName || ''}`.trim() || 'User'}
										</Text>
										{roleText && roleText !== 'none' && (
											<Text font12 inter regular grey3 style={{ whiteSpace: 'nowrap' }}>
												{roleText}
											</Text>
										)}
									</Flexbox>
								}
								position="Right"
								hide={!collapsed}
								zIndex="9999"
								minWidth="max-content"
								maxWidth="max-content"
							>
								<Flexbox alignCenter gap={16} className="mb12" contentCenter={collapsed}>
									<InitialsAvatar
										firstName={authData?.firstName}
										lastName={authData?.lastName}
										size={40}
									/>
									{!collapsed && (
										<Flexbox column>
											<Text font16 inter medium white>{authData?.firstName || "User"}</Text>
											<Text font12 inter regular grey2>{roleText}</Text>
										</Flexbox>
									)}
								</Flexbox>
							</ToolTip>
						</div>
						<div style={{ display: 'flex', justifyContent: collapsed ? 'center' : 'flex-start' }}>
							<ToolTip content="Logout" position="Right" hide={!collapsed} zIndex="9999" minWidth="max-content" maxWidth="max-content">
								<Flexbox gap={12} padding={'12px 0'} className="pointer" contentCenter={collapsed}
									onClick={() => {
										setPopupState(true);
										setIsActiveMenu(false);
									}}
								>
									<LogOut/>
									{!collapsed && <Text font16 inter semiBold red>Logout</Text>}
								</Flexbox>
							</ToolTip>
						</div>
					</div>
				</Flexbox>
			</div>
		</>
	);
};

export default MainSideMenu;
